import { render, staticRenderFns } from "./typeform.vue?vue&type=template&id=58d95f32&scoped=true&v-once=true"
import script from "./typeform.vue?vue&type=script&lang=js"
export * from "./typeform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d95f32",
  null
  
)

export default component.exports